export default __webpack_public_path__ + "static/media/online-accounts-icon.9623d7c3.svg";